import { useEffect } from 'react'
import { motion, useSpring, useTransform } from 'framer-motion'

interface ProgressBarProps {
  currentStep: number
  totalSteps: number
}

const ProgressBar = ({ currentStep, totalSteps }: ProgressBarProps) => {
  const springProgress = useSpring((currentStep / totalSteps) * 100, {
    stiffness: 100,
    damping: 20,
    mass: 0.5
  })

  useEffect(() => {
    const progressPercentage = (currentStep / totalSteps) * 100
    springProgress.set(progressPercentage)
  }, [currentStep, totalSteps, springProgress])

  return (
    <div className="w-full h-1 flex gap-2">
      {Array.from({ length: totalSteps }).map((_, index) => (
        <div key={index} className="relative flex flex-row flex-1">
          <div className="absolute top-0 left-0 w-full h-1 bg-zinc-100 rounded-full overflow-hidden">
            <motion.div
              className="absolute top-0 left-0 h-full bg-blue-600 rounded-full"
              style={{
                width: useTransform(
                  springProgress,
                  [
                    (index / totalSteps) * 100,
                    ((index + 1) / totalSteps) * 100
                  ],
                  ['0%', '100%']
                )
              }}
            />
          </div>
        </div>
      ))}
    </div>
  )
}

export default ProgressBar